export const useNotificationTimestamp = () => { 

  const addTimestamp = (originalUser: IUserMetaDataApi, editedUser: IUserMetaDataApi): IUserMetaDataApi => {
    const updatedUser = { ...editedUser };
    if (!updatedUser.newsletterSubscriptionUpdate) {
      updatedUser.newsletterSubscriptionUpdate = {};
    }

    const originalNewsletter = originalUser.newsletterSubscription || {};
    const editedNewsletter = editedUser.newsletterSubscription || {};
    const currentTimestamp = new Date().toISOString();

    Object.keys(editedNewsletter).forEach((key) => {
      const newsletterKey = key as keyof INewsletterSubscription;
      const originalValue = originalNewsletter[newsletterKey];
      const editedValue = editedNewsletter[newsletterKey];

      // undefinedとfalseは同等に扱う
      const normalizedOriginal = originalValue === undefined ? false : originalValue;
      const normalizedEdited = editedValue === undefined ? false : editedValue;

      if (normalizedOriginal !== normalizedEdited) {
        if (!updatedUser.newsletterSubscriptionUpdate![newsletterKey]) {
          updatedUser.newsletterSubscriptionUpdate![newsletterKey] = {};
        }

        const existingTimestamps = originalUser.newsletterSubscriptionUpdate?.[newsletterKey] || {};
        if (normalizedEdited === true) {
          updatedUser.newsletterSubscriptionUpdate![newsletterKey] = {
            ...existingTimestamps,
            on: currentTimestamp
          };
        } else if (normalizedEdited === false && normalizedOriginal === true) {
          // ON => OFF の場合のみタイムスタンプを追加
          updatedUser.newsletterSubscriptionUpdate![newsletterKey] = {
            ...existingTimestamps,
            off: currentTimestamp
          };
        }
      }
    });

    return updatedUser;
  }

  // mailmagidからメルマガのデフォルト値をセットする
  const checkNewsletterFromMailmagId = (mailMagid: string, userMetadata: IUserMetaDataApi): IUserMetaDataApi => {
    const fields: { [key: string]: string } = {
      sendenkaigiInfo: "1",
      classInfo: "2",
      contestsAwards: "5",
      editorialBooks: "7",
      editorialSendenkaigi: "8",
      editorialBrain: "9",
      editorialHansokukaigi: "10",
      editorialKohokaigi: "11",
      // environmentalBusinessOnline: "13",
      advertimes: "14",
      digitalMagazine: "15",
      adPlacementSponsorship: "16",
      jobChangeInfo: "19",
      businessCardExchangeList: "20"
    };

    const ids = mailMagid.split(",");
    const updatedNewsletterSubscription: INewsletterSubscription = { ...userMetadata.newsletterSubscription };
    ids.forEach((id) => {
      const matchedKey = Object.keys(fields).find((key) => fields[key] === id);
      if (matchedKey) {
        const newsletterKey = matchedKey as keyof INewsletterSubscription;
        updatedNewsletterSubscription[newsletterKey] = true;
      }
    });

    return {
      ...userMetadata,
      newsletterSubscription: updatedNewsletterSubscription
    };
  }

  return {
    addTimestamp,
    checkNewsletterFromMailmagId
  };
}
